import axios from "axios";

const products = {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        async getLastGoodsBuy(context, payload) {
            let response = await axios.post(`/get_last_goods_buy`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getProductForChangePrice() {
            let response = await axios.get(`/get_product_for_change_price`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getByTitle(context, payload) {
            let response = await axios.post(`/product_list_by_title`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getByGroupID(context, payload) {
            let response = await axios.get(`/product_list_by_group_id/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getCartex(context, payload) {
            let response = await axios.get(`/get_goods_cartex/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getByID(context, payload) {
            let response = await axios.get(`/product_list_by_id/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getImagePic(context, payload) {
            let response = await axios.get(`/get_product_image_from_bank/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async deleteProductImage(context, payload) {
            let response = await axios.get(`/delete_product_image/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getGoodsGroup(context, payload) {
            let response = await axios.post(`/get_goods_group_list`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getGroupInfo(context, payload) {
            let response = await axios.get(`/get_goods_group_info/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getGoodsList(context, payload) {
            let response = await axios.post(`/get_goods_list`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getGoodsGroupList(context, payload) {
            let response = await axios.post(`/get_goods_group_list_summary`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getStoreList() {
            let response = await axios.get(`/get_store_list`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async insertGoodsStoreD(context, payload) {
            let response = await axios.post(`/goods_store_insert`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async addGoodsTransfer(context, payload) {
            let response = await axios.post(`/add_goods_transfer_request`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async acceptGoodsTransfer(context, payload) {
            let response = await axios.post(`/accept_goods_transfer_request`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getGoodsTransferList(context, payload) {
            let response = await axios.get(`/get_goods_transfer_list/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getGoodsTransferDetails(context, payload) {
            let response = await axios.get(`/get_goods_transfer_request_details/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async generateGoodsTransferRequest(context, payload) {
            let response = await axios.get(`/generate_transfer_request_list/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async setGoodsTransferRequestConfirm(context, payload) {
            let response = await axios.get(`/set_confirm_goods_stored/${payload.Goods_IDD}/${payload.Goods_ID}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async deleteGoodsTransfer(context, payload) {
            let response = await axios.get(`/delete_transfer_request/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async changeProductState(context, payload) {
            let response = await axios.get(`/change_product_state/${payload.Goods_ID}/${payload.State_ID}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async changeProductGroupState(context, payload) {
            let response = await axios.get(`/change_product_group_state/${payload.Group_ID}/${payload.State_ID}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async loadProductState() {
            let response = await axios.get(`/get_product_states`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async loadDependencyGoods(context, payload) {
            let response = await axios.get(`/load_dependency_goods/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async setProductDependency(context, payload) {
            let response = await axios.post(`/modify_goods_dependeny`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getReserveExiWithGoodsID(context, payload) {
            let response = await axios.get(`/get_reserve_exi_with_goods_id/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getFactorInfo(context, payload) {
            let response = await axios.get(`/get_factor_info/${payload.Sale_Num}/${payload.Sale_Kind}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getProductInfo(context, payload) {
            let response = await axios.get(`/product_info/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getCustomerRelation(context, payload) {
            const response = await axios.get(`/customer_product_group_relation/${payload.groupIds}/${payload.flag}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getGoodsCustomerRelation(context, payload) {
            const response = await axios.get(`/customer_product_goods_relation/${payload.goodsId}/${payload.flag}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getLastSaleGoodByCustomer(context, payload) {
            const response = await axios.get(`/get_last_sale_good_by_customer/${payload.CustomerId}/${payload.GoodsId}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getGoodsUnits() {
            const response = await axios.get(`/get_goods_units`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async addProduct(context, payload) {
            const response = await axios.post(`/insert_product`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async updateGoodsPrice(context, payload) {
            const response = await axios.post(`/update_goods_price`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async addGoodsGroup(context, payload) {
            const response = await axios.post(`/add_goods_group`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async clearGoodsStoreItemConfirm(context, payload) {
            const response = await axios.get(`/clear_goods_store_item_confirm/${payload.ID}/${payload.Goods_ID}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getProductPriceTraceList(context, payload) {
            let response = await axios.get(`/get_goods_price_trace_list/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getGoodsSuppliers(context, payload) {
            let response = await axios.get(`/get_goods_suppliers/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getGoodsGroupSuppliers(context, payload) {
            let response = await axios.get(`/get_goods_group_suppliers/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getGoodsGroupDashBoard(context, payload) {
            let response = await axios.get(`/get_goods_group_dashboard/${payload.startDate}/${payload.endDate}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async changeGoodsGroupPrice(context, payload) {
            let response = await axios.post(`/change_goods_price`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getGoodsBuySaleMonthInCurrentYear(context, payload) {
            let response = await axios.get(`/goods_buy_sale_month_in_current_year/${payload.goods_Id}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getSimpleGoodsGroupList() {
            let response = await axios.get(`/get_simple_goods_group_list`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getGroupTree() {
            let response = await axios.get(`/group_tree_list`);
            return response.data
        },
        async addGoodsGroupTree(context, payload) {
            let response = await axios.post(`/add_goods_group_tree`, payload);
            return response.data
        },
        async deleteGoodsGroupTree(context, payload) {
            let response = await axios.delete(`/delete_goods_group_tree/${payload.id}`);
            return response.data
        }

    },
    getters: {}
}

export default products;
